import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getTranslator } from '../../Translator';
import { getPartyById, getElectionById, getCandidateById } from '../../selectors';
import { ElectionStatus, VoteResult } from '../../_generatedTypes.g';
import { approveCandidacy } from '../../features/candidate/candidatesSlice';
import { VoteButton } from './VoteButton';
import { EditOptions } from './EditOptions';
import { useAppSelector } from '../../hooks';

type CandidateButtonRowProps = {
    candidateId: number;
    onClickVote(): void;
}

export const CandidateButtonRow = (props: CandidateButtonRowProps) => {
    const { candidateId, onClickVote } = props;
    const language = useAppSelector(state => state.language);
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);
    const isAdmin = useAppSelector(state => state.clientState.Account.IsAdmin);
    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const elections = useAppSelector(state => state.elections);

    const hasCandidacy = useAppSelector(state => state.clientState.HasCandidacy);
    const t = getTranslator(language);
    const dispatch = useDispatch();

    const candidate = getCandidateById(candidates, candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    const election = getElectionById(elections, party.ElectionId);
    const voteResult = election.VoteResult;
    let backLink = election && election.CandidateSystem ? `/election/${election.ElectionId}/candidates` : `/party/${party.PartyId}`;
    if (voteResult === VoteResult.Success) {
        backLink = '/';
    }

    return <div className="buttonrow">
        <VoteButton candidateId={candidateId} onClickVote={onClickVote} />
        {(hasCandidacy
            && !election.CandidateSystem
            && (election.ElectionStatus == ElectionStatus.CandidacyPeriod || election.ElectionStatus == ElectionStatus.NotYetOpen)
            && !candidate.IsApproved
            && candidate.IsCurrentAccountCandidate)
            &&
            <button id="Candidate-Approve" type="button" className="button--important"
                onClick={() => { if (confirm(t.translate({ NL: 'Weet u zeker dat u kandidaat wilt worden?', EN: 'Are u sure you want to become a candidate?' }))) { approveCandidacy(candidate, token, dispatch) } }}>
                {t['Approve my candidacy']}
            </button>
        }
        {(hasCandidacy
            && !election.CandidateSystem
            && (election.ElectionStatus == ElectionStatus.CandidacyPeriod || election.ElectionStatus == ElectionStatus.NotYetOpen)
            && !candidate.IsApproved
            && isAdmin)
            &&
            <button id="Admin-Approve" type="button" className="button--important"
                onClick={() => { approveCandidacy(candidate, token, dispatch) }}>
                {t.translate({ NL: 'Keur kandidaatstelling goed', EN: 'Approve candidacy' })}
            </button>
        }
        <EditOptions candidateId={candidateId} />
        <Link className="linkbutton" to={backLink}>{t['Back']}</Link>
    </div>
}
